export const getNotificationApi = ( query) => {
    const queryString = new URLSearchParams(query).toString();
    return `/notifications/${queryString ? `?${queryString}` : ""}`;
};
